// extracted by mini-css-extract-plugin
export default {"root":"HeathTermsOfService_root__3c5PL","prop65List":"HeathTermsOfService_prop65List__2ufYN"};